module.exports = __webpack_public_path__ + "img/icon-update.6a8e6b98.svg";